import styled from 'styled-components';
import InformationCard from 'src/components/informationCard';
import Button from 'src/components/buttons/button';
import i18n from 'src/utils/translate';
import { trackFootfallEvent } from 'src/utils/footfall';
import { Event, Element, Section } from 'src/constants/footfall';
import { useModalTrigger } from 'src/utils/hooks';
import { ModalType } from 'src/constants/modalTypes';
export default function ImproveSimilarToMeRecommendationsCard() {
  const triggerProfileSurveyModal = useModalTrigger(ModalType.ProfileSurvey);
  const clickProfileSurvey = () => {
    trackFootfallEvent(Event.Clicked, {
      clickType: 'profile-survey',
      clickMetadata: {
        section: Section.CommunityMembers,
        element: Element.ImproveModule
      }
    });
    triggerProfileSurveyModal();
  };
  return <Container data-sentry-element="Container" data-sentry-component="ImproveSimilarToMeRecommendationsCard" data-sentry-source-file="improveSimilarToMeRecommendationsCard.tsx">
      <InformationCard data-sentry-element="InformationCard" data-sentry-source-file="improveSimilarToMeRecommendationsCard.tsx">
        <Title data-sentry-element="Title" data-sentry-source-file="improveSimilarToMeRecommendationsCard.tsx">{i18n.t('Improve your recommendations')}</Title>
        <Paragraph data-sentry-element="Paragraph" data-sentry-source-file="improveSimilarToMeRecommendationsCard.tsx">{i18n.t("The 'Similar to me' filter recommends users based on how similar their profile is to yours.")}</Paragraph>
        <Button text={i18n.t('Update your profile')} onClick={clickProfileSurvey} data-sentry-element="Button" data-sentry-source-file="improveSimilarToMeRecommendationsCard.tsx" />
      </InformationCard>
    </Container>;
}
const Container = styled.div`
  max-width: 500px;
`;
const Title = styled.p`
  font-weight: bold;
  margin-bottom: 10px;
`;
const Paragraph = styled.p`
  margin-bottom: 10px;
`;